import React, { useMemo } from "react";
import clsx from "clsx";
import { isEmpty } from "lodash";
import { useFormContext } from "react-hook-form";

import { Button, Skeleton } from "components";
import { FormColumn, FormRow } from "components/layout";
import { permissionList, useRequiredPermissions } from "helpers";
import { useLoader } from "hooks";
import { CopyInfoData } from "types";

import styles from "./paymentMethod.module.scss";

type CopyInfoProps = {
	copyInfoData?: CopyInfoData;
	isLoadingCopyInfoData?: boolean;
	isModal: boolean;
	isApplication?: boolean;
	isBillToAgent?: boolean;
};

export const CopyInfo = ({
	copyInfoData,
	isLoadingCopyInfoData,
	isModal,
	isApplication = false,
	isBillToAgent = false,
}: CopyInfoProps) => {
	const { setValue } = useFormContext();

	const hasViewFullPermission = useRequiredPermissions(
		permissionList.ViewSensitiveAccountDataFull,
	);

	const handleChangeCopyBankInfo = async () => {
		if (isEmpty(copyInfoData)) return;
		Object.keys(copyInfoData).forEach(key => {
			if (!isEmpty(copyInfoData[key])) {
				setValue(key, copyInfoData[key], {
					shouldValidate: true,
					shouldDirty: true,
				});
			}
		});
	};

	const Loader = useLoader(isLoadingCopyInfoData);

	const copyBtnText = useMemo(() => {
		let text = "Copy from merchant banking info";
		if (isBillToAgent) {
			text = "Copy ACH details from Residuals payout info";
		} else if (isApplication && !isBillToAgent) {
			text = "Copy from application business info";
		}

		return text;
	}, [isApplication, isBillToAgent]);

	return (
		<Loader
			skeleton={<Skeleton height="40px" className="mb-3" />}
			component={
				<>
					{hasViewFullPermission && (
						<FormRow>
							<FormColumn
								className={clsx(
									isModal && styles.modalFormColumnFull,
								)}
							>
								<Button
									onClick={handleChangeCopyBankInfo}
									value={copyBtnText}
									variant="secondary"
									className="pl-0 mb-3"
								/>
							</FormColumn>
						</FormRow>
					)}
				</>
			}
		/>
	);
};
